export default __webpack_public_path__ + "30bcd5374a562c97bff97bfcf4ae5433.svg";